/**
 * Z-index configuration based on the existing CSS custom properties
 */
export const zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
  // Custom z-indexes based on CSS custom properties
  dropdown: 1000, // --z-index-dropdown
  sticky: 1020, // --z-index-sticky
  fixed: 1030, // --z-index-fixed
  modalBackdrop: 1040, // --z-index-modal-backdrop
  popover: 1060, // --z-index-popover
  toast: 1080, // --z-index-toast
};